import { render, staticRenderFns } from "./planstep3.vue?vue&type=template&id=0a26f782&scoped=true"
import script from "./planstep3.vue?vue&type=script&lang=js"
export * from "./planstep3.vue?vue&type=script&lang=js"
import style0 from "./planstep3.vue?vue&type=style&index=0&id=0a26f782&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a26f782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a26f782')) {
      api.createRecord('0a26f782', component.options)
    } else {
      api.reload('0a26f782', component.options)
    }
    module.hot.accept("./planstep3.vue?vue&type=template&id=0a26f782&scoped=true", function () {
      api.rerender('0a26f782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setting/pricing/planstep3.vue"
export default component.exports